import { c as _c } from "react/compiler-runtime";
// @ts-nocheck
import { Percent, CurrencyUSD, Time, GraphQLDecimal } from '@/graphql/scalars';
import * as Types from '../../../types/schema';
import { FormsAnswerReview_SubmissionFragment } from '../../../modules/forms/graphql/FormSubmissions.generated';
import { gql } from '@apollo/client';
import { FormsAnswerReview_SubmissionFragmentDoc } from '../../../modules/forms/graphql/FormSubmissions.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateFormTestSnapshotMutationVariables = Types.Exact<{
  input: Types.CreateFormTestSnapshotInput;
}>;
export type CreateFormTestSnapshotMutation = {
  __typename?: 'Mutation';
  createFormTestSnapshot: {
    __typename?: 'FormVersion';
    id: string;
    version: number;
  };
};
export type RunFormTestMutationVariables = Types.Exact<{
  input: Types.RunFormTestInput;
}>;
export type RunFormTestMutation = {
  __typename?: 'Mutation';
  runFormTest: Array<{
    __typename?: 'Submission';
    id: string;
  }>;
};
export type AdminFormTestHistoryQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  after?: Types.InputMaybe<Types.Scalars['Cursor']['input']>;
}>;
export type AdminFormTestHistoryQuery = {
  __typename?: 'Query';
  node?: {
    __typename?: 'AISuggestion';
  } | {
    __typename?: 'AISuggestionEvidence';
  } | {
    __typename?: 'AccessAgeParameter';
  } | {
    __typename?: 'AccessParameter';
  } | {
    __typename?: 'Account';
  } | {
    __typename?: 'ActiveEstateInsightsPage';
  } | {
    __typename?: 'Activity';
  } | {
    __typename?: 'Address';
  } | {
    __typename?: 'Answer';
  } | {
    __typename?: 'AnswerEvidence';
  } | {
    __typename?: 'AnswerRevision';
  } | {
    __typename?: 'Approval';
  } | {
    __typename?: 'AssetClass';
  } | {
    __typename?: 'AssetGroup';
  } | {
    __typename?: 'AssetStatic';
  } | {
    __typename?: 'AssetV2';
  } | {
    __typename?: 'AssetValuationV2';
  } | {
    __typename?: 'AssetValueV2';
  } | {
    __typename?: 'AsyncJob';
  } | {
    __typename?: 'BalanceSheetBundleConfiguration';
  } | {
    __typename?: 'BalanceSheetCategory';
  } | {
    __typename?: 'BalanceSheetViewConfiguration';
  } | {
    __typename?: 'BeneficiariesBundleConfiguration';
  } | {
    __typename?: 'BeneficiariesTemplateBundleConfiguration';
  } | {
    __typename?: 'Beneficiary';
  } | {
    __typename?: 'BeneficiaryAccessParameter';
  } | {
    __typename?: 'BeneficiaryDesignationGroup';
  } | {
    __typename?: 'BeneficiaryDistribution';
  } | {
    __typename?: 'BeneficiaryDistributionParameter';
  } | {
    __typename?: 'BeneficiaryPage';
  } | {
    __typename?: 'BeneficiaryPowerOfAppointment';
  } | {
    __typename?: 'CCorpBusinessEntity';
  } | {
    __typename?: 'CLTProposal';
  } | {
    __typename?: 'CLTTrust';
  } | {
    __typename?: 'CRTProposal';
  } | {
    __typename?: 'CRTTrust';
  } | {
    __typename?: 'Capability';
  } | {
    __typename?: 'Cashflow';
  } | {
    __typename?: 'ClientOrganization';
  } | {
    __typename?: 'ClientPresentationV2';
  } | {
    __typename?: 'ClientProfile';
  } | {
    __typename?: 'ClientProfileRelationship';
  } | {
    __typename?: 'Collaborator';
  } | {
    __typename?: 'ComparedWaterfall';
  } | {
    __typename?: 'CompletedEstateInsightsPage';
  } | {
    __typename?: 'ControllingParty';
  } | {
    __typename?: 'Conversation';
  } | {
    __typename?: 'CoverPageConfiguration';
  } | {
    __typename?: 'CustodialPersonalAccount';
  } | {
    __typename?: 'DSUEPortability';
  } | {
    __typename?: 'DiagramArtifact';
  } | {
    __typename?: 'DiagramArtifactPrompt';
  } | {
    __typename?: 'DispositionScenario';
  } | {
    __typename?: 'DispositiveProvision';
  } | {
    __typename?: 'DispositiveProvisionTemplate';
  } | {
    __typename?: 'DividerBundleConfiguration';
  } | {
    __typename?: 'DividerTemplateBundleConfiguration';
  } | {
    __typename?: 'Document';
  } | {
    __typename?: 'DocumentQuestion';
  } | {
    __typename?: 'DocumentQuestionAnswers';
  } | {
    __typename?: 'DocumentSummary';
  } | {
    __typename?: 'DocumentSummaryPage';
  } | {
    __typename?: 'DocumentSummaryPrompt';
  } | {
    __typename?: 'DocumentSummaryPromptTestRun';
  } | {
    __typename?: 'DocumentSummaryTemplateBundleConfiguration';
  } | {
    __typename?: 'DonorAdvisedFund';
  } | {
    __typename?: 'Employee';
  } | {
    __typename?: 'EntitiesOverviewBundleConfiguration';
  } | {
    __typename?: 'EntitiesOverviewBundleConfigurationEntity';
  } | {
    __typename?: 'Entity';
  } | {
    __typename?: 'EntityDiagram';
  } | {
    __typename?: 'EntityDocumentRelationship';
  } | {
    __typename?: 'EntityGraphView';
  } | {
    __typename?: 'EntityGraphViewBundleConfiguration';
  } | {
    __typename?: 'EntityNotes';
  } | {
    __typename?: 'EntityProposal';
  } | {
    __typename?: 'EntitySummaryBundleConfiguration';
  } | {
    __typename?: 'EntitySummaryTemplateBundleConfiguration';
  } | {
    __typename?: 'EntityTask';
  } | {
    __typename?: 'EntityTaxInfo';
  } | {
    __typename?: 'EstateInsight';
  } | {
    __typename?: 'EstateInsightReference';
  } | {
    __typename?: 'EstateInsightsBundleConfiguration';
  } | {
    __typename?: 'EstateTaxScenario';
  } | {
    __typename?: 'EstateWaterfall';
  } | {
    __typename?: 'EstateWaterfallHypotheticalStateChange';
  } | {
    __typename?: 'EstateWaterfallHypotheticalTransfer';
  } | {
    __typename?: 'EstateWaterfallMessageContext';
  } | {
    __typename?: 'EstateWaterfallVisualizationConfig';
  } | {
    __typename?: 'EstateWaterfallVisualizationFilter';
  } | {
    __typename?: 'FamilyTreeBundleConfiguration';
  } | {
    __typename?: 'FamilyTreeConfiguration';
  } | {
    __typename?: 'FeatureFlag';
  } | {
    __typename?: 'FeatureFlagQueryRule';
  } | {
    __typename?: 'File';
  } | {
    __typename?: 'FilePage';
  } | {
    __typename?: 'FileParagraph';
  } | {
    __typename?: 'Form';
    id: string;
    versions: {
      __typename?: 'FormVersionConnection';
      edges?: Array<{
        __typename?: 'FormVersionEdge';
        node?: {
          __typename?: 'FormVersion';
          id: string;
          version: number;
          createdAt: Time;
        } | null;
      } | null> | null;
      pageInfo: {
        __typename?: 'PageInfo';
        endCursor?: any | null;
        hasNextPage: boolean;
      };
    };
  } | {
    __typename?: 'FormVersion';
  } | {
    __typename?: 'GPBusinessEntity';
  } | {
    __typename?: 'GRATAnnuityV2';
  } | {
    __typename?: 'GRATProposalScenario';
  } | {
    __typename?: 'GRATTrust';
  } | {
    __typename?: 'GiftingProposal';
  } | {
    __typename?: 'GiftingProposalCashFlow';
  } | {
    __typename?: 'GiftingProposalGift';
  } | {
    __typename?: 'GiftingProposalGiftSender';
  } | {
    __typename?: 'GiftingProposalPortfolio';
  } | {
    __typename?: 'GiftingProposalScenario';
  } | {
    __typename?: 'GraphVisualizationGroup';
  } | {
    __typename?: 'GrowthProfile';
  } | {
    __typename?: 'GrowthProfileOverride';
  } | {
    __typename?: 'Household';
  } | {
    __typename?: 'HypotheticalCLT';
  } | {
    __typename?: 'HypotheticalCRT';
  } | {
    __typename?: 'HypotheticalGRAT';
  } | {
    __typename?: 'HypotheticalInsurance';
  } | {
    __typename?: 'HypotheticalSaleLoan';
  } | {
    __typename?: 'HypotheticalTransferAsset';
  } | {
    __typename?: 'HypotheticalTransferFundingSource';
  } | {
    __typename?: 'HypotheticalWaterfallDispositiveProvisionTemplate';
  } | {
    __typename?: 'ILITCrummeyLetter';
  } | {
    __typename?: 'ILITTrust';
  } | {
    __typename?: 'Image';
  } | {
    __typename?: 'IncomeTaxPaymentConfig';
  } | {
    __typename?: 'IndividualPersonalAccount';
  } | {
    __typename?: 'InferredField';
  } | {
    __typename?: 'InferredFieldEvidence';
  } | {
    __typename?: 'InsightsTemplateBundleConfiguration';
  } | {
    __typename?: 'InsurancePersonalAccount';
  } | {
    __typename?: 'InsurancePolicy';
  } | {
    __typename?: 'InsurancePremiumPayment';
  } | {
    __typename?: 'IntegrationAssetClass';
  } | {
    __typename?: 'IntegrationCashflow';
  } | {
    __typename?: 'IntegrationClient';
  } | {
    __typename?: 'IntegrationConfiguration';
  } | {
    __typename?: 'IntegrationEntity';
  } | {
    __typename?: 'IntegrationInsurance';
  } | {
    __typename?: 'IntegrationLiability';
  } | {
    __typename?: 'IntegrationPerson';
  } | {
    __typename?: 'IrrevocableTrust';
  } | {
    __typename?: 'JointPersonalAccount';
  } | {
    __typename?: 'KGNode';
  } | {
    __typename?: 'KGRelationship';
  } | {
    __typename?: 'KGRoot';
  } | {
    __typename?: 'KGV2Document';
  } | {
    __typename?: 'KGV2DocumentChange';
  } | {
    __typename?: 'KGV2DocumentModification';
  } | {
    __typename?: 'KGV2Graph';
  } | {
    __typename?: 'KGV2Node';
  } | {
    __typename?: 'KGV2NodeAlias';
  } | {
    __typename?: 'KGV2NodeEvidence';
  } | {
    __typename?: 'KGV2Statement';
  } | {
    __typename?: 'KGV2StatementEvidence';
  } | {
    __typename?: 'KGV2StatementSupersession';
  } | {
    __typename?: 'KeyPerson';
  } | {
    __typename?: 'KeyPersonRole';
  } | {
    __typename?: 'LLCBusinessEntity';
  } | {
    __typename?: 'LPBusinessEntity';
  } | {
    __typename?: 'LiabilitiesBundleConfiguration';
  } | {
    __typename?: 'Liability';
  } | {
    __typename?: 'LiabilityPayment';
  } | {
    __typename?: 'LifeInsuranceBundleConfiguration';
  } | {
    __typename?: 'LifetimeExclusionEvent';
  } | {
    __typename?: 'LoggedTransfer';
  } | {
    __typename?: 'LuminaryOrganization';
  } | {
    __typename?: 'LuminaryTenantJIT';
  } | {
    __typename?: 'ManagedSFTPConnection';
  } | {
    __typename?: 'Memo';
  } | {
    __typename?: 'MemoPrompt';
  } | {
    __typename?: 'Message';
  } | {
    __typename?: 'MissingDocumentOverride';
  } | {
    __typename?: 'MissingDocumentsPage';
  } | {
    __typename?: 'ModelMapping';
  } | {
    __typename?: 'NotificationApp';
  } | {
    __typename?: 'NotificationPreference';
  } | {
    __typename?: 'OpenaiSdkConfig';
  } | {
    __typename?: 'OrganizationApplicationConfiguration';
  } | {
    __typename?: 'OrganizationDisclaimerConfiguration';
  } | {
    __typename?: 'OwnershipStake';
  } | {
    __typename?: 'PlatformDocument';
  } | {
    __typename?: 'PlatformFile';
  } | {
    __typename?: 'PlatformFilePage';
  } | {
    __typename?: 'PlatformFileParagraph';
  } | {
    __typename?: 'PresentationApprovalRequest';
  } | {
    __typename?: 'PresentationAssetDistributionBundleConfiguration';
  } | {
    __typename?: 'PresentationAssetDistributionItemConfiguration';
  } | {
    __typename?: 'PresentationAssetDistributionItemDetail';
  } | {
    __typename?: 'PresentationBundle';
  } | {
    __typename?: 'PresentationBundleCoverPage';
  } | {
    __typename?: 'PresentationBusinessOverviewBundleConfiguration';
  } | {
    __typename?: 'PresentationBusinessOverviewBusinessConfiguration';
  } | {
    __typename?: 'PresentationBusinessOverviewItem';
  } | {
    __typename?: 'PresentationCoverPage';
  } | {
    __typename?: 'PresentationCoverSlideConfig';
  } | {
    __typename?: 'PresentationCustomPage';
  } | {
    __typename?: 'PresentationCustomPageBundleConfiguration';
  } | {
    __typename?: 'PresentationDiagramPage';
  } | {
    __typename?: 'PresentationDocumentsReviewedBundleConfiguration';
  } | {
    __typename?: 'PresentationDocumentsReviewedDocument';
  } | {
    __typename?: 'PresentationFamilyOverviewBundleConfiguration';
  } | {
    __typename?: 'PresentationFamilyOverviewMemberConfiguration';
  } | {
    __typename?: 'PresentationHealthcareDirectiveBundleConfiguration';
  } | {
    __typename?: 'PresentationHealthcareDirectiveClientConfiguration';
  } | {
    __typename?: 'PresentationHealthcareDirectiveItem';
  } | {
    __typename?: 'PresentationItemCitation';
  } | {
    __typename?: 'PresentationPage';
  } | {
    __typename?: 'PresentationPlanningOpportunitiesBundleConfiguration';
  } | {
    __typename?: 'PresentationPlanningOpportunitiesItem';
  } | {
    __typename?: 'PresentationPowerOfAttorneyBundleConfiguration';
  } | {
    __typename?: 'PresentationPowerOfAttorneyClientConfiguration';
  } | {
    __typename?: 'PresentationPowerOfAttorneyItem';
  } | {
    __typename?: 'PresentationTemplate';
  } | {
    __typename?: 'PresentationTemplateBundle';
  } | {
    __typename?: 'PresentationTemplateCoverPage';
  } | {
    __typename?: 'PresentationTemplateCustomPage';
  } | {
    __typename?: 'PresentationTemplateDiagramPage';
  } | {
    __typename?: 'PresentationTemplatePage';
  } | {
    __typename?: 'PresentationTrustOverviewBundleConfiguration';
  } | {
    __typename?: 'PresentationTrustOverviewItem';
  } | {
    __typename?: 'PresentationTrustOverviewTrustConfiguration';
  } | {
    __typename?: 'PresentationWillBundleConfiguration';
  } | {
    __typename?: 'PresentationWillClientConfiguration';
  } | {
    __typename?: 'PresentationWillItem';
  } | {
    __typename?: 'Principal';
  } | {
    __typename?: 'PrivateFoundation';
  } | {
    __typename?: 'ProfessionalTeamRole';
  } | {
    __typename?: 'Proposal';
  } | {
    __typename?: 'ProposalScenario';
  } | {
    __typename?: 'QPRTTrust';
  } | {
    __typename?: 'QualifiedTuitionPersonalAccount';
  } | {
    __typename?: 'ReleaseGroup';
  } | {
    __typename?: 'ReminderEmailNotificationRecord';
  } | {
    __typename?: 'RetirementPersonalAccount';
  } | {
    __typename?: 'RevocableTrust';
  } | {
    __typename?: 'Role';
  } | {
    __typename?: 'SCorpBusinessEntity';
  } | {
    __typename?: 'SLATTrust';
  } | {
    __typename?: 'SSOConnection';
  } | {
    __typename?: 'SalesforceExportAttempt';
  } | {
    __typename?: 'ScheduledDistribution';
  } | {
    __typename?: 'SoleProprietorshipBusinessEntity';
  } | {
    __typename?: 'SubBrand';
  } | {
    __typename?: 'SubBrandDisclaimerConfiguration';
  } | {
    __typename?: 'Submission';
  } | {
    __typename?: 'TaxDragConfig';
  } | {
    __typename?: 'TaxDragOverride';
  } | {
    __typename?: 'Team';
  } | {
    __typename?: 'Tenant';
  } | {
    __typename?: 'TenantApplicationConfiguration';
  } | {
    __typename?: 'TenantBranding';
  } | {
    __typename?: 'TenantDisclaimerConfiguration';
  } | {
    __typename?: 'TenantDocument';
  } | {
    __typename?: 'TenantReminderEmailsConfiguration';
  } | {
    __typename?: 'TenantSSOConnection';
  } | {
    __typename?: 'TenantSecurityConfiguration';
  } | {
    __typename?: 'TenantSlideConfig';
  } | {
    __typename?: 'TestCMKEncryption';
  } | {
    __typename?: 'TestamentaryEntity';
  } | {
    __typename?: 'TrustAdvisor';
  } | {
    __typename?: 'TrustAdvisorRole';
  } | {
    __typename?: 'Trustee';
  } | {
    __typename?: 'TrusteeDuty';
  } | {
    __typename?: 'User';
  } | {
    __typename?: 'UserFeedback';
  } | {
    __typename?: 'UserNotificationConfiguration';
  } | {
    __typename?: 'WaterfallBundleConfiguration';
  } | {
    __typename?: 'WaterfallBundleCoverPage';
  } | {
    __typename?: 'WaterfallComparisonBundleConfiguration';
  } | {
    __typename?: 'WaterfallComparisonTemplateBundleConfiguration';
  } | {
    __typename?: 'WaterfallTemplateBundleConfiguration';
  } | {
    __typename?: 'WorkOSOrganization';
  } | {
    __typename?: 'WorkOSOrganizationDomain';
  } | {
    __typename?: 'WorkflowTracker';
  } | null;
};
export type AdminFormTestHouseholdsQueryVariables = Types.Exact<{
  search: Types.Scalars['String']['input'];
}>;
export type AdminFormTestHouseholdsQuery = {
  __typename?: 'Query';
  households: {
    __typename?: 'HouseholdConnection';
    edges?: Array<{
      __typename?: 'HouseholdEdge';
      node?: {
        __typename?: 'Household';
        id: string;
        name: string;
      } | null;
    } | null> | null;
  };
};
export type AdminFormTestResultsQueryVariables = Types.Exact<{
  versionID: Types.Scalars['ID']['input'];
}>;
export type AdminFormTestResultsQuery = {
  __typename?: 'Query';
  node?: {
    __typename?: 'AISuggestion';
  } | {
    __typename?: 'AISuggestionEvidence';
  } | {
    __typename?: 'AccessAgeParameter';
  } | {
    __typename?: 'AccessParameter';
  } | {
    __typename?: 'Account';
  } | {
    __typename?: 'ActiveEstateInsightsPage';
  } | {
    __typename?: 'Activity';
  } | {
    __typename?: 'Address';
  } | {
    __typename?: 'Answer';
  } | {
    __typename?: 'AnswerEvidence';
  } | {
    __typename?: 'AnswerRevision';
  } | {
    __typename?: 'Approval';
  } | {
    __typename?: 'AssetClass';
  } | {
    __typename?: 'AssetGroup';
  } | {
    __typename?: 'AssetStatic';
  } | {
    __typename?: 'AssetV2';
  } | {
    __typename?: 'AssetValuationV2';
  } | {
    __typename?: 'AssetValueV2';
  } | {
    __typename?: 'AsyncJob';
  } | {
    __typename?: 'BalanceSheetBundleConfiguration';
  } | {
    __typename?: 'BalanceSheetCategory';
  } | {
    __typename?: 'BalanceSheetViewConfiguration';
  } | {
    __typename?: 'BeneficiariesBundleConfiguration';
  } | {
    __typename?: 'BeneficiariesTemplateBundleConfiguration';
  } | {
    __typename?: 'Beneficiary';
  } | {
    __typename?: 'BeneficiaryAccessParameter';
  } | {
    __typename?: 'BeneficiaryDesignationGroup';
  } | {
    __typename?: 'BeneficiaryDistribution';
  } | {
    __typename?: 'BeneficiaryDistributionParameter';
  } | {
    __typename?: 'BeneficiaryPage';
  } | {
    __typename?: 'BeneficiaryPowerOfAppointment';
  } | {
    __typename?: 'CCorpBusinessEntity';
  } | {
    __typename?: 'CLTProposal';
  } | {
    __typename?: 'CLTTrust';
  } | {
    __typename?: 'CRTProposal';
  } | {
    __typename?: 'CRTTrust';
  } | {
    __typename?: 'Capability';
  } | {
    __typename?: 'Cashflow';
  } | {
    __typename?: 'ClientOrganization';
  } | {
    __typename?: 'ClientPresentationV2';
  } | {
    __typename?: 'ClientProfile';
  } | {
    __typename?: 'ClientProfileRelationship';
  } | {
    __typename?: 'Collaborator';
  } | {
    __typename?: 'ComparedWaterfall';
  } | {
    __typename?: 'CompletedEstateInsightsPage';
  } | {
    __typename?: 'ControllingParty';
  } | {
    __typename?: 'Conversation';
  } | {
    __typename?: 'CoverPageConfiguration';
  } | {
    __typename?: 'CustodialPersonalAccount';
  } | {
    __typename?: 'DSUEPortability';
  } | {
    __typename?: 'DiagramArtifact';
  } | {
    __typename?: 'DiagramArtifactPrompt';
  } | {
    __typename?: 'DispositionScenario';
  } | {
    __typename?: 'DispositiveProvision';
  } | {
    __typename?: 'DispositiveProvisionTemplate';
  } | {
    __typename?: 'DividerBundleConfiguration';
  } | {
    __typename?: 'DividerTemplateBundleConfiguration';
  } | {
    __typename?: 'Document';
  } | {
    __typename?: 'DocumentQuestion';
  } | {
    __typename?: 'DocumentQuestionAnswers';
  } | {
    __typename?: 'DocumentSummary';
  } | {
    __typename?: 'DocumentSummaryPage';
  } | {
    __typename?: 'DocumentSummaryPrompt';
  } | {
    __typename?: 'DocumentSummaryPromptTestRun';
  } | {
    __typename?: 'DocumentSummaryTemplateBundleConfiguration';
  } | {
    __typename?: 'DonorAdvisedFund';
  } | {
    __typename?: 'Employee';
  } | {
    __typename?: 'EntitiesOverviewBundleConfiguration';
  } | {
    __typename?: 'EntitiesOverviewBundleConfigurationEntity';
  } | {
    __typename?: 'Entity';
  } | {
    __typename?: 'EntityDiagram';
  } | {
    __typename?: 'EntityDocumentRelationship';
  } | {
    __typename?: 'EntityGraphView';
  } | {
    __typename?: 'EntityGraphViewBundleConfiguration';
  } | {
    __typename?: 'EntityNotes';
  } | {
    __typename?: 'EntityProposal';
  } | {
    __typename?: 'EntitySummaryBundleConfiguration';
  } | {
    __typename?: 'EntitySummaryTemplateBundleConfiguration';
  } | {
    __typename?: 'EntityTask';
  } | {
    __typename?: 'EntityTaxInfo';
  } | {
    __typename?: 'EstateInsight';
  } | {
    __typename?: 'EstateInsightReference';
  } | {
    __typename?: 'EstateInsightsBundleConfiguration';
  } | {
    __typename?: 'EstateTaxScenario';
  } | {
    __typename?: 'EstateWaterfall';
  } | {
    __typename?: 'EstateWaterfallHypotheticalStateChange';
  } | {
    __typename?: 'EstateWaterfallHypotheticalTransfer';
  } | {
    __typename?: 'EstateWaterfallMessageContext';
  } | {
    __typename?: 'EstateWaterfallVisualizationConfig';
  } | {
    __typename?: 'EstateWaterfallVisualizationFilter';
  } | {
    __typename?: 'FamilyTreeBundleConfiguration';
  } | {
    __typename?: 'FamilyTreeConfiguration';
  } | {
    __typename?: 'FeatureFlag';
  } | {
    __typename?: 'FeatureFlagQueryRule';
  } | {
    __typename?: 'File';
  } | {
    __typename?: 'FilePage';
  } | {
    __typename?: 'FileParagraph';
  } | {
    __typename?: 'Form';
  } | {
    __typename?: 'FormVersion';
    id: string;
    version: number;
    createdAt: Time;
    kind: Types.FormVersionKind;
    schemaVersion: number;
    config: any;
    form: {
      __typename?: 'Form';
      id: string;
    };
  } | {
    __typename?: 'GPBusinessEntity';
  } | {
    __typename?: 'GRATAnnuityV2';
  } | {
    __typename?: 'GRATProposalScenario';
  } | {
    __typename?: 'GRATTrust';
  } | {
    __typename?: 'GiftingProposal';
  } | {
    __typename?: 'GiftingProposalCashFlow';
  } | {
    __typename?: 'GiftingProposalGift';
  } | {
    __typename?: 'GiftingProposalGiftSender';
  } | {
    __typename?: 'GiftingProposalPortfolio';
  } | {
    __typename?: 'GiftingProposalScenario';
  } | {
    __typename?: 'GraphVisualizationGroup';
  } | {
    __typename?: 'GrowthProfile';
  } | {
    __typename?: 'GrowthProfileOverride';
  } | {
    __typename?: 'Household';
  } | {
    __typename?: 'HypotheticalCLT';
  } | {
    __typename?: 'HypotheticalCRT';
  } | {
    __typename?: 'HypotheticalGRAT';
  } | {
    __typename?: 'HypotheticalInsurance';
  } | {
    __typename?: 'HypotheticalSaleLoan';
  } | {
    __typename?: 'HypotheticalTransferAsset';
  } | {
    __typename?: 'HypotheticalTransferFundingSource';
  } | {
    __typename?: 'HypotheticalWaterfallDispositiveProvisionTemplate';
  } | {
    __typename?: 'ILITCrummeyLetter';
  } | {
    __typename?: 'ILITTrust';
  } | {
    __typename?: 'Image';
  } | {
    __typename?: 'IncomeTaxPaymentConfig';
  } | {
    __typename?: 'IndividualPersonalAccount';
  } | {
    __typename?: 'InferredField';
  } | {
    __typename?: 'InferredFieldEvidence';
  } | {
    __typename?: 'InsightsTemplateBundleConfiguration';
  } | {
    __typename?: 'InsurancePersonalAccount';
  } | {
    __typename?: 'InsurancePolicy';
  } | {
    __typename?: 'InsurancePremiumPayment';
  } | {
    __typename?: 'IntegrationAssetClass';
  } | {
    __typename?: 'IntegrationCashflow';
  } | {
    __typename?: 'IntegrationClient';
  } | {
    __typename?: 'IntegrationConfiguration';
  } | {
    __typename?: 'IntegrationEntity';
  } | {
    __typename?: 'IntegrationInsurance';
  } | {
    __typename?: 'IntegrationLiability';
  } | {
    __typename?: 'IntegrationPerson';
  } | {
    __typename?: 'IrrevocableTrust';
  } | {
    __typename?: 'JointPersonalAccount';
  } | {
    __typename?: 'KGNode';
  } | {
    __typename?: 'KGRelationship';
  } | {
    __typename?: 'KGRoot';
  } | {
    __typename?: 'KGV2Document';
  } | {
    __typename?: 'KGV2DocumentChange';
  } | {
    __typename?: 'KGV2DocumentModification';
  } | {
    __typename?: 'KGV2Graph';
  } | {
    __typename?: 'KGV2Node';
  } | {
    __typename?: 'KGV2NodeAlias';
  } | {
    __typename?: 'KGV2NodeEvidence';
  } | {
    __typename?: 'KGV2Statement';
  } | {
    __typename?: 'KGV2StatementEvidence';
  } | {
    __typename?: 'KGV2StatementSupersession';
  } | {
    __typename?: 'KeyPerson';
  } | {
    __typename?: 'KeyPersonRole';
  } | {
    __typename?: 'LLCBusinessEntity';
  } | {
    __typename?: 'LPBusinessEntity';
  } | {
    __typename?: 'LiabilitiesBundleConfiguration';
  } | {
    __typename?: 'Liability';
  } | {
    __typename?: 'LiabilityPayment';
  } | {
    __typename?: 'LifeInsuranceBundleConfiguration';
  } | {
    __typename?: 'LifetimeExclusionEvent';
  } | {
    __typename?: 'LoggedTransfer';
  } | {
    __typename?: 'LuminaryOrganization';
  } | {
    __typename?: 'LuminaryTenantJIT';
  } | {
    __typename?: 'ManagedSFTPConnection';
  } | {
    __typename?: 'Memo';
  } | {
    __typename?: 'MemoPrompt';
  } | {
    __typename?: 'Message';
  } | {
    __typename?: 'MissingDocumentOverride';
  } | {
    __typename?: 'MissingDocumentsPage';
  } | {
    __typename?: 'ModelMapping';
  } | {
    __typename?: 'NotificationApp';
  } | {
    __typename?: 'NotificationPreference';
  } | {
    __typename?: 'OpenaiSdkConfig';
  } | {
    __typename?: 'OrganizationApplicationConfiguration';
  } | {
    __typename?: 'OrganizationDisclaimerConfiguration';
  } | {
    __typename?: 'OwnershipStake';
  } | {
    __typename?: 'PlatformDocument';
  } | {
    __typename?: 'PlatformFile';
  } | {
    __typename?: 'PlatformFilePage';
  } | {
    __typename?: 'PlatformFileParagraph';
  } | {
    __typename?: 'PresentationApprovalRequest';
  } | {
    __typename?: 'PresentationAssetDistributionBundleConfiguration';
  } | {
    __typename?: 'PresentationAssetDistributionItemConfiguration';
  } | {
    __typename?: 'PresentationAssetDistributionItemDetail';
  } | {
    __typename?: 'PresentationBundle';
  } | {
    __typename?: 'PresentationBundleCoverPage';
  } | {
    __typename?: 'PresentationBusinessOverviewBundleConfiguration';
  } | {
    __typename?: 'PresentationBusinessOverviewBusinessConfiguration';
  } | {
    __typename?: 'PresentationBusinessOverviewItem';
  } | {
    __typename?: 'PresentationCoverPage';
  } | {
    __typename?: 'PresentationCoverSlideConfig';
  } | {
    __typename?: 'PresentationCustomPage';
  } | {
    __typename?: 'PresentationCustomPageBundleConfiguration';
  } | {
    __typename?: 'PresentationDiagramPage';
  } | {
    __typename?: 'PresentationDocumentsReviewedBundleConfiguration';
  } | {
    __typename?: 'PresentationDocumentsReviewedDocument';
  } | {
    __typename?: 'PresentationFamilyOverviewBundleConfiguration';
  } | {
    __typename?: 'PresentationFamilyOverviewMemberConfiguration';
  } | {
    __typename?: 'PresentationHealthcareDirectiveBundleConfiguration';
  } | {
    __typename?: 'PresentationHealthcareDirectiveClientConfiguration';
  } | {
    __typename?: 'PresentationHealthcareDirectiveItem';
  } | {
    __typename?: 'PresentationItemCitation';
  } | {
    __typename?: 'PresentationPage';
  } | {
    __typename?: 'PresentationPlanningOpportunitiesBundleConfiguration';
  } | {
    __typename?: 'PresentationPlanningOpportunitiesItem';
  } | {
    __typename?: 'PresentationPowerOfAttorneyBundleConfiguration';
  } | {
    __typename?: 'PresentationPowerOfAttorneyClientConfiguration';
  } | {
    __typename?: 'PresentationPowerOfAttorneyItem';
  } | {
    __typename?: 'PresentationTemplate';
  } | {
    __typename?: 'PresentationTemplateBundle';
  } | {
    __typename?: 'PresentationTemplateCoverPage';
  } | {
    __typename?: 'PresentationTemplateCustomPage';
  } | {
    __typename?: 'PresentationTemplateDiagramPage';
  } | {
    __typename?: 'PresentationTemplatePage';
  } | {
    __typename?: 'PresentationTrustOverviewBundleConfiguration';
  } | {
    __typename?: 'PresentationTrustOverviewItem';
  } | {
    __typename?: 'PresentationTrustOverviewTrustConfiguration';
  } | {
    __typename?: 'PresentationWillBundleConfiguration';
  } | {
    __typename?: 'PresentationWillClientConfiguration';
  } | {
    __typename?: 'PresentationWillItem';
  } | {
    __typename?: 'Principal';
  } | {
    __typename?: 'PrivateFoundation';
  } | {
    __typename?: 'ProfessionalTeamRole';
  } | {
    __typename?: 'Proposal';
  } | {
    __typename?: 'ProposalScenario';
  } | {
    __typename?: 'QPRTTrust';
  } | {
    __typename?: 'QualifiedTuitionPersonalAccount';
  } | {
    __typename?: 'ReleaseGroup';
  } | {
    __typename?: 'ReminderEmailNotificationRecord';
  } | {
    __typename?: 'RetirementPersonalAccount';
  } | {
    __typename?: 'RevocableTrust';
  } | {
    __typename?: 'Role';
  } | {
    __typename?: 'SCorpBusinessEntity';
  } | {
    __typename?: 'SLATTrust';
  } | {
    __typename?: 'SSOConnection';
  } | {
    __typename?: 'SalesforceExportAttempt';
  } | {
    __typename?: 'ScheduledDistribution';
  } | {
    __typename?: 'SoleProprietorshipBusinessEntity';
  } | {
    __typename?: 'SubBrand';
  } | {
    __typename?: 'SubBrandDisclaimerConfiguration';
  } | {
    __typename?: 'Submission';
  } | {
    __typename?: 'TaxDragConfig';
  } | {
    __typename?: 'TaxDragOverride';
  } | {
    __typename?: 'Team';
  } | {
    __typename?: 'Tenant';
  } | {
    __typename?: 'TenantApplicationConfiguration';
  } | {
    __typename?: 'TenantBranding';
  } | {
    __typename?: 'TenantDisclaimerConfiguration';
  } | {
    __typename?: 'TenantDocument';
  } | {
    __typename?: 'TenantReminderEmailsConfiguration';
  } | {
    __typename?: 'TenantSSOConnection';
  } | {
    __typename?: 'TenantSecurityConfiguration';
  } | {
    __typename?: 'TenantSlideConfig';
  } | {
    __typename?: 'TestCMKEncryption';
  } | {
    __typename?: 'TestamentaryEntity';
  } | {
    __typename?: 'TrustAdvisor';
  } | {
    __typename?: 'TrustAdvisorRole';
  } | {
    __typename?: 'Trustee';
  } | {
    __typename?: 'TrusteeDuty';
  } | {
    __typename?: 'User';
  } | {
    __typename?: 'UserFeedback';
  } | {
    __typename?: 'UserNotificationConfiguration';
  } | {
    __typename?: 'WaterfallBundleConfiguration';
  } | {
    __typename?: 'WaterfallBundleCoverPage';
  } | {
    __typename?: 'WaterfallComparisonBundleConfiguration';
  } | {
    __typename?: 'WaterfallComparisonTemplateBundleConfiguration';
  } | {
    __typename?: 'WaterfallTemplateBundleConfiguration';
  } | {
    __typename?: 'WorkOSOrganization';
  } | {
    __typename?: 'WorkOSOrganizationDomain';
  } | {
    __typename?: 'WorkflowTracker';
  } | null;
  submissions: {
    __typename?: 'SubmissionConnection';
    edges?: Array<{
      __typename?: 'SubmissionEdge';
      node?: {
        __typename?: 'Submission';
        id: string;
        status: Types.SubmissionStatus;
        household: {
          __typename?: 'Household';
          id: string;
          name: string;
        };
        sourceDocuments: {
          __typename?: 'DocumentConnection';
          edges?: Array<{
            __typename?: 'DocumentEdge';
            node?: {
              __typename?: 'Document';
              id: string;
              name: string;
            } | null;
          } | null> | null;
        };
        answers?: Array<{
          __typename?: 'Answer';
          id: string;
          fieldID: string;
          latestAIRevision?: {
            __typename?: 'AnswerRevision';
            id: string;
            value?: any | null;
            confidence?: Types.AnswerRevisionConfidence | null;
            reasoning?: string | null;
            evidence?: Array<{
              __typename?: 'AnswerEvidence';
              id: string;
              document: {
                __typename?: 'Document';
                id: string;
                name: string;
              };
              fileParagraphs?: Array<{
                __typename?: 'FileParagraph';
                id: string;
                content: string;
              }> | null;
            }> | null;
          } | null;
        }> | null;
      } | null;
    } | null> | null;
  };
};
export type AdminFormTestSubmissionQueryVariables = Types.Exact<{
  submissionID: Types.Scalars['ID']['input'];
  sourceAfter?: Types.InputMaybe<Types.Scalars['Cursor']['input']>;
}>;
export type AdminFormTestSubmissionQuery = {
  __typename?: 'Query';
  node?: {
    __typename: 'AISuggestion';
  } | {
    __typename: 'AISuggestionEvidence';
  } | {
    __typename: 'AccessAgeParameter';
  } | {
    __typename: 'AccessParameter';
  } | {
    __typename: 'Account';
  } | {
    __typename: 'ActiveEstateInsightsPage';
  } | {
    __typename: 'Activity';
  } | {
    __typename: 'Address';
  } | {
    __typename: 'Answer';
  } | {
    __typename: 'AnswerEvidence';
  } | {
    __typename: 'AnswerRevision';
  } | {
    __typename: 'Approval';
  } | {
    __typename: 'AssetClass';
  } | {
    __typename: 'AssetGroup';
  } | {
    __typename: 'AssetStatic';
  } | {
    __typename: 'AssetV2';
  } | {
    __typename: 'AssetValuationV2';
  } | {
    __typename: 'AssetValueV2';
  } | {
    __typename: 'AsyncJob';
  } | {
    __typename: 'BalanceSheetBundleConfiguration';
  } | {
    __typename: 'BalanceSheetCategory';
  } | {
    __typename: 'BalanceSheetViewConfiguration';
  } | {
    __typename: 'BeneficiariesBundleConfiguration';
  } | {
    __typename: 'BeneficiariesTemplateBundleConfiguration';
  } | {
    __typename: 'Beneficiary';
  } | {
    __typename: 'BeneficiaryAccessParameter';
  } | {
    __typename: 'BeneficiaryDesignationGroup';
  } | {
    __typename: 'BeneficiaryDistribution';
  } | {
    __typename: 'BeneficiaryDistributionParameter';
  } | {
    __typename: 'BeneficiaryPage';
  } | {
    __typename: 'BeneficiaryPowerOfAppointment';
  } | {
    __typename: 'CCorpBusinessEntity';
  } | {
    __typename: 'CLTProposal';
  } | {
    __typename: 'CLTTrust';
  } | {
    __typename: 'CRTProposal';
  } | {
    __typename: 'CRTTrust';
  } | {
    __typename: 'Capability';
  } | {
    __typename: 'Cashflow';
  } | {
    __typename: 'ClientOrganization';
  } | {
    __typename: 'ClientPresentationV2';
  } | {
    __typename: 'ClientProfile';
  } | {
    __typename: 'ClientProfileRelationship';
  } | {
    __typename: 'Collaborator';
  } | {
    __typename: 'ComparedWaterfall';
  } | {
    __typename: 'CompletedEstateInsightsPage';
  } | {
    __typename: 'ControllingParty';
  } | {
    __typename: 'Conversation';
  } | {
    __typename: 'CoverPageConfiguration';
  } | {
    __typename: 'CustodialPersonalAccount';
  } | {
    __typename: 'DSUEPortability';
  } | {
    __typename: 'DiagramArtifact';
  } | {
    __typename: 'DiagramArtifactPrompt';
  } | {
    __typename: 'DispositionScenario';
  } | {
    __typename: 'DispositiveProvision';
  } | {
    __typename: 'DispositiveProvisionTemplate';
  } | {
    __typename: 'DividerBundleConfiguration';
  } | {
    __typename: 'DividerTemplateBundleConfiguration';
  } | {
    __typename: 'Document';
  } | {
    __typename: 'DocumentQuestion';
  } | {
    __typename: 'DocumentQuestionAnswers';
  } | {
    __typename: 'DocumentSummary';
  } | {
    __typename: 'DocumentSummaryPage';
  } | {
    __typename: 'DocumentSummaryPrompt';
  } | {
    __typename: 'DocumentSummaryPromptTestRun';
  } | {
    __typename: 'DocumentSummaryTemplateBundleConfiguration';
  } | {
    __typename: 'DonorAdvisedFund';
  } | {
    __typename: 'Employee';
  } | {
    __typename: 'EntitiesOverviewBundleConfiguration';
  } | {
    __typename: 'EntitiesOverviewBundleConfigurationEntity';
  } | {
    __typename: 'Entity';
  } | {
    __typename: 'EntityDiagram';
  } | {
    __typename: 'EntityDocumentRelationship';
  } | {
    __typename: 'EntityGraphView';
  } | {
    __typename: 'EntityGraphViewBundleConfiguration';
  } | {
    __typename: 'EntityNotes';
  } | {
    __typename: 'EntityProposal';
  } | {
    __typename: 'EntitySummaryBundleConfiguration';
  } | {
    __typename: 'EntitySummaryTemplateBundleConfiguration';
  } | {
    __typename: 'EntityTask';
  } | {
    __typename: 'EntityTaxInfo';
  } | {
    __typename: 'EstateInsight';
  } | {
    __typename: 'EstateInsightReference';
  } | {
    __typename: 'EstateInsightsBundleConfiguration';
  } | {
    __typename: 'EstateTaxScenario';
  } | {
    __typename: 'EstateWaterfall';
  } | {
    __typename: 'EstateWaterfallHypotheticalStateChange';
  } | {
    __typename: 'EstateWaterfallHypotheticalTransfer';
  } | {
    __typename: 'EstateWaterfallMessageContext';
  } | {
    __typename: 'EstateWaterfallVisualizationConfig';
  } | {
    __typename: 'EstateWaterfallVisualizationFilter';
  } | {
    __typename: 'FamilyTreeBundleConfiguration';
  } | {
    __typename: 'FamilyTreeConfiguration';
  } | {
    __typename: 'FeatureFlag';
  } | {
    __typename: 'FeatureFlagQueryRule';
  } | {
    __typename: 'File';
  } | {
    __typename: 'FilePage';
  } | {
    __typename: 'FileParagraph';
  } | {
    __typename: 'Form';
  } | {
    __typename: 'FormVersion';
  } | {
    __typename: 'GPBusinessEntity';
  } | {
    __typename: 'GRATAnnuityV2';
  } | {
    __typename: 'GRATProposalScenario';
  } | {
    __typename: 'GRATTrust';
  } | {
    __typename: 'GiftingProposal';
  } | {
    __typename: 'GiftingProposalCashFlow';
  } | {
    __typename: 'GiftingProposalGift';
  } | {
    __typename: 'GiftingProposalGiftSender';
  } | {
    __typename: 'GiftingProposalPortfolio';
  } | {
    __typename: 'GiftingProposalScenario';
  } | {
    __typename: 'GraphVisualizationGroup';
  } | {
    __typename: 'GrowthProfile';
  } | {
    __typename: 'GrowthProfileOverride';
  } | {
    __typename: 'Household';
  } | {
    __typename: 'HypotheticalCLT';
  } | {
    __typename: 'HypotheticalCRT';
  } | {
    __typename: 'HypotheticalGRAT';
  } | {
    __typename: 'HypotheticalInsurance';
  } | {
    __typename: 'HypotheticalSaleLoan';
  } | {
    __typename: 'HypotheticalTransferAsset';
  } | {
    __typename: 'HypotheticalTransferFundingSource';
  } | {
    __typename: 'HypotheticalWaterfallDispositiveProvisionTemplate';
  } | {
    __typename: 'ILITCrummeyLetter';
  } | {
    __typename: 'ILITTrust';
  } | {
    __typename: 'Image';
  } | {
    __typename: 'IncomeTaxPaymentConfig';
  } | {
    __typename: 'IndividualPersonalAccount';
  } | {
    __typename: 'InferredField';
  } | {
    __typename: 'InferredFieldEvidence';
  } | {
    __typename: 'InsightsTemplateBundleConfiguration';
  } | {
    __typename: 'InsurancePersonalAccount';
  } | {
    __typename: 'InsurancePolicy';
  } | {
    __typename: 'InsurancePremiumPayment';
  } | {
    __typename: 'IntegrationAssetClass';
  } | {
    __typename: 'IntegrationCashflow';
  } | {
    __typename: 'IntegrationClient';
  } | {
    __typename: 'IntegrationConfiguration';
  } | {
    __typename: 'IntegrationEntity';
  } | {
    __typename: 'IntegrationInsurance';
  } | {
    __typename: 'IntegrationLiability';
  } | {
    __typename: 'IntegrationPerson';
  } | {
    __typename: 'IrrevocableTrust';
  } | {
    __typename: 'JointPersonalAccount';
  } | {
    __typename: 'KGNode';
  } | {
    __typename: 'KGRelationship';
  } | {
    __typename: 'KGRoot';
  } | {
    __typename: 'KGV2Document';
  } | {
    __typename: 'KGV2DocumentChange';
  } | {
    __typename: 'KGV2DocumentModification';
  } | {
    __typename: 'KGV2Graph';
  } | {
    __typename: 'KGV2Node';
  } | {
    __typename: 'KGV2NodeAlias';
  } | {
    __typename: 'KGV2NodeEvidence';
  } | {
    __typename: 'KGV2Statement';
  } | {
    __typename: 'KGV2StatementEvidence';
  } | {
    __typename: 'KGV2StatementSupersession';
  } | {
    __typename: 'KeyPerson';
  } | {
    __typename: 'KeyPersonRole';
  } | {
    __typename: 'LLCBusinessEntity';
  } | {
    __typename: 'LPBusinessEntity';
  } | {
    __typename: 'LiabilitiesBundleConfiguration';
  } | {
    __typename: 'Liability';
  } | {
    __typename: 'LiabilityPayment';
  } | {
    __typename: 'LifeInsuranceBundleConfiguration';
  } | {
    __typename: 'LifetimeExclusionEvent';
  } | {
    __typename: 'LoggedTransfer';
  } | {
    __typename: 'LuminaryOrganization';
  } | {
    __typename: 'LuminaryTenantJIT';
  } | {
    __typename: 'ManagedSFTPConnection';
  } | {
    __typename: 'Memo';
  } | {
    __typename: 'MemoPrompt';
  } | {
    __typename: 'Message';
  } | {
    __typename: 'MissingDocumentOverride';
  } | {
    __typename: 'MissingDocumentsPage';
  } | {
    __typename: 'ModelMapping';
  } | {
    __typename: 'NotificationApp';
  } | {
    __typename: 'NotificationPreference';
  } | {
    __typename: 'OpenaiSdkConfig';
  } | {
    __typename: 'OrganizationApplicationConfiguration';
  } | {
    __typename: 'OrganizationDisclaimerConfiguration';
  } | {
    __typename: 'OwnershipStake';
  } | {
    __typename: 'PlatformDocument';
  } | {
    __typename: 'PlatformFile';
  } | {
    __typename: 'PlatformFilePage';
  } | {
    __typename: 'PlatformFileParagraph';
  } | {
    __typename: 'PresentationApprovalRequest';
  } | {
    __typename: 'PresentationAssetDistributionBundleConfiguration';
  } | {
    __typename: 'PresentationAssetDistributionItemConfiguration';
  } | {
    __typename: 'PresentationAssetDistributionItemDetail';
  } | {
    __typename: 'PresentationBundle';
  } | {
    __typename: 'PresentationBundleCoverPage';
  } | {
    __typename: 'PresentationBusinessOverviewBundleConfiguration';
  } | {
    __typename: 'PresentationBusinessOverviewBusinessConfiguration';
  } | {
    __typename: 'PresentationBusinessOverviewItem';
  } | {
    __typename: 'PresentationCoverPage';
  } | {
    __typename: 'PresentationCoverSlideConfig';
  } | {
    __typename: 'PresentationCustomPage';
  } | {
    __typename: 'PresentationCustomPageBundleConfiguration';
  } | {
    __typename: 'PresentationDiagramPage';
  } | {
    __typename: 'PresentationDocumentsReviewedBundleConfiguration';
  } | {
    __typename: 'PresentationDocumentsReviewedDocument';
  } | {
    __typename: 'PresentationFamilyOverviewBundleConfiguration';
  } | {
    __typename: 'PresentationFamilyOverviewMemberConfiguration';
  } | {
    __typename: 'PresentationHealthcareDirectiveBundleConfiguration';
  } | {
    __typename: 'PresentationHealthcareDirectiveClientConfiguration';
  } | {
    __typename: 'PresentationHealthcareDirectiveItem';
  } | {
    __typename: 'PresentationItemCitation';
  } | {
    __typename: 'PresentationPage';
  } | {
    __typename: 'PresentationPlanningOpportunitiesBundleConfiguration';
  } | {
    __typename: 'PresentationPlanningOpportunitiesItem';
  } | {
    __typename: 'PresentationPowerOfAttorneyBundleConfiguration';
  } | {
    __typename: 'PresentationPowerOfAttorneyClientConfiguration';
  } | {
    __typename: 'PresentationPowerOfAttorneyItem';
  } | {
    __typename: 'PresentationTemplate';
  } | {
    __typename: 'PresentationTemplateBundle';
  } | {
    __typename: 'PresentationTemplateCoverPage';
  } | {
    __typename: 'PresentationTemplateCustomPage';
  } | {
    __typename: 'PresentationTemplateDiagramPage';
  } | {
    __typename: 'PresentationTemplatePage';
  } | {
    __typename: 'PresentationTrustOverviewBundleConfiguration';
  } | {
    __typename: 'PresentationTrustOverviewItem';
  } | {
    __typename: 'PresentationTrustOverviewTrustConfiguration';
  } | {
    __typename: 'PresentationWillBundleConfiguration';
  } | {
    __typename: 'PresentationWillClientConfiguration';
  } | {
    __typename: 'PresentationWillItem';
  } | {
    __typename: 'Principal';
  } | {
    __typename: 'PrivateFoundation';
  } | {
    __typename: 'ProfessionalTeamRole';
  } | {
    __typename: 'Proposal';
  } | {
    __typename: 'ProposalScenario';
  } | {
    __typename: 'QPRTTrust';
  } | {
    __typename: 'QualifiedTuitionPersonalAccount';
  } | {
    __typename: 'ReleaseGroup';
  } | {
    __typename: 'ReminderEmailNotificationRecord';
  } | {
    __typename: 'RetirementPersonalAccount';
  } | {
    __typename: 'RevocableTrust';
  } | {
    __typename: 'Role';
  } | {
    __typename: 'SCorpBusinessEntity';
  } | {
    __typename: 'SLATTrust';
  } | {
    __typename: 'SSOConnection';
  } | {
    __typename: 'SalesforceExportAttempt';
  } | {
    __typename: 'ScheduledDistribution';
  } | {
    __typename: 'SoleProprietorshipBusinessEntity';
  } | {
    __typename: 'SubBrand';
  } | {
    __typename: 'SubBrandDisclaimerConfiguration';
  } | ({
    __typename: 'Submission';
    household: {
      __typename?: 'Household';
      id: string;
      name: string;
    };
    formVersion: {
      __typename?: 'FormVersion';
      id: string;
      kind: Types.FormVersionKind;
      form: {
        __typename?: 'Form';
        id: string;
      };
    };
  } & FormsAnswerReview_SubmissionFragment) | {
    __typename: 'TaxDragConfig';
  } | {
    __typename: 'TaxDragOverride';
  } | {
    __typename: 'Team';
  } | {
    __typename: 'Tenant';
  } | {
    __typename: 'TenantApplicationConfiguration';
  } | {
    __typename: 'TenantBranding';
  } | {
    __typename: 'TenantDisclaimerConfiguration';
  } | {
    __typename: 'TenantDocument';
  } | {
    __typename: 'TenantReminderEmailsConfiguration';
  } | {
    __typename: 'TenantSSOConnection';
  } | {
    __typename: 'TenantSecurityConfiguration';
  } | {
    __typename: 'TenantSlideConfig';
  } | {
    __typename: 'TestCMKEncryption';
  } | {
    __typename: 'TestamentaryEntity';
  } | {
    __typename: 'TrustAdvisor';
  } | {
    __typename: 'TrustAdvisorRole';
  } | {
    __typename: 'Trustee';
  } | {
    __typename: 'TrusteeDuty';
  } | {
    __typename: 'User';
  } | {
    __typename: 'UserFeedback';
  } | {
    __typename: 'UserNotificationConfiguration';
  } | {
    __typename: 'WaterfallBundleConfiguration';
  } | {
    __typename: 'WaterfallBundleCoverPage';
  } | {
    __typename: 'WaterfallComparisonBundleConfiguration';
  } | {
    __typename: 'WaterfallComparisonTemplateBundleConfiguration';
  } | {
    __typename: 'WaterfallTemplateBundleConfiguration';
  } | {
    __typename: 'WorkOSOrganization';
  } | {
    __typename: 'WorkOSOrganizationDomain';
  } | {
    __typename: 'WorkflowTracker';
  } | null;
};
export const Operations = {
  Query: {
    AdminFormTestHistory: 'AdminFormTestHistory' as const,
    AdminFormTestHouseholds: 'AdminFormTestHouseholds' as const,
    AdminFormTestResults: 'AdminFormTestResults' as const,
    AdminFormTestSubmission: 'AdminFormTestSubmission' as const
  },
  Mutation: {
    CreateFormTestSnapshot: 'CreateFormTestSnapshot' as const,
    RunFormTest: 'RunFormTest' as const
  }
};

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy
    }
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options
  };
}
export const CreateFormTestSnapshotDocument = gql`
    mutation CreateFormTestSnapshot($input: CreateFormTestSnapshotInput!) {
  createFormTestSnapshot(input: $input) {
    id
    version
  }
}
    `;
export type CreateFormTestSnapshotMutationFn = Apollo.MutationFunction<CreateFormTestSnapshotMutation, CreateFormTestSnapshotMutationVariables>;

/**
 * __useCreateFormTestSnapshotMutation__
 *
 * To run a mutation, you first call `useCreateFormTestSnapshotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFormTestSnapshotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFormTestSnapshotMutation, { data, loading, error }] = useCreateFormTestSnapshotMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFormTestSnapshotMutation(baseOptions) {
  const $ = _c(2);
  let t0;
  if ($[0] !== baseOptions) {
    t0 = {
      ...defaultOptions,
      ...baseOptions
    };
    $[0] = baseOptions;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const options = t0;
  return Apollo.useMutation(CreateFormTestSnapshotDocument, options);
}
export type CreateFormTestSnapshotMutationHookResult = ReturnType<typeof useCreateFormTestSnapshotMutation>;
export type CreateFormTestSnapshotMutationResult = Apollo.MutationResult<CreateFormTestSnapshotMutation>;
export type CreateFormTestSnapshotMutationOptions = Apollo.BaseMutationOptions<CreateFormTestSnapshotMutation, CreateFormTestSnapshotMutationVariables>;
export const RunFormTestDocument = gql`
    mutation RunFormTest($input: RunFormTestInput!) {
  runFormTest(input: $input) {
    id
  }
}
    `;
export type RunFormTestMutationFn = Apollo.MutationFunction<RunFormTestMutation, RunFormTestMutationVariables>;

/**
 * __useRunFormTestMutation__
 *
 * To run a mutation, you first call `useRunFormTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunFormTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runFormTestMutation, { data, loading, error }] = useRunFormTestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRunFormTestMutation(baseOptions) {
  const $ = _c(2);
  let t0;
  if ($[0] !== baseOptions) {
    t0 = {
      ...defaultOptions,
      ...baseOptions
    };
    $[0] = baseOptions;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const options = t0;
  return Apollo.useMutation(RunFormTestDocument, options);
}
export type RunFormTestMutationHookResult = ReturnType<typeof useRunFormTestMutation>;
export type RunFormTestMutationResult = Apollo.MutationResult<RunFormTestMutation>;
export type RunFormTestMutationOptions = Apollo.BaseMutationOptions<RunFormTestMutation, RunFormTestMutationVariables>;
export const AdminFormTestHistoryDocument = gql`
    query AdminFormTestHistory($id: ID!, $after: Cursor) {
  node(id: $id) {
    ... on Form {
      id
      versions(
        first: 20
        after: $after
        where: {kind: TEST}
        orderBy: [{field: created_at, direction: DESC}]
      ) {
        edges {
          node {
            id
            version
            createdAt
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  }
}
    `;

/**
 * __useAdminFormTestHistoryQuery__
 *
 * To run a query within a React component, call `useAdminFormTestHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminFormTestHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminFormTestHistoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useAdminFormTestHistoryQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useQuery(AdminFormTestHistoryDocument, withFetchPolicyContext(options));
}
export function useAdminFormTestHistoryLazyQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useLazyQuery(AdminFormTestHistoryDocument, withFetchPolicyContext({
    ...options,
    isLazy: true
  }));
}
export function useAdminFormTestHistorySuspenseQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useSuspenseQuery(AdminFormTestHistoryDocument, withFetchPolicyContext(options));
}
export type AdminFormTestHistoryQueryHookResult = ReturnType<typeof useAdminFormTestHistoryQuery>;
export type AdminFormTestHistoryLazyQueryHookResult = ReturnType<typeof useAdminFormTestHistoryLazyQuery>;
export type AdminFormTestHistorySuspenseQueryHookResult = ReturnType<typeof useAdminFormTestHistorySuspenseQuery>;
export type AdminFormTestHistoryQueryResult = Apollo.QueryResult<AdminFormTestHistoryQuery, AdminFormTestHistoryQueryVariables>;
export const AdminFormTestHouseholdsDocument = gql`
    query AdminFormTestHouseholds($search: String!) {
  households: searchHouseholds(first: 50, query: $search) {
    edges {
      node {
        id
        name: displayName
      }
    }
  }
}
    `;

/**
 * __useAdminFormTestHouseholdsQuery__
 *
 * To run a query within a React component, call `useAdminFormTestHouseholdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminFormTestHouseholdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminFormTestHouseholdsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useAdminFormTestHouseholdsQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useQuery(AdminFormTestHouseholdsDocument, withFetchPolicyContext(options));
}
export function useAdminFormTestHouseholdsLazyQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useLazyQuery(AdminFormTestHouseholdsDocument, withFetchPolicyContext({
    ...options,
    isLazy: true
  }));
}
export function useAdminFormTestHouseholdsSuspenseQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useSuspenseQuery(AdminFormTestHouseholdsDocument, withFetchPolicyContext(options));
}
export type AdminFormTestHouseholdsQueryHookResult = ReturnType<typeof useAdminFormTestHouseholdsQuery>;
export type AdminFormTestHouseholdsLazyQueryHookResult = ReturnType<typeof useAdminFormTestHouseholdsLazyQuery>;
export type AdminFormTestHouseholdsSuspenseQueryHookResult = ReturnType<typeof useAdminFormTestHouseholdsSuspenseQuery>;
export type AdminFormTestHouseholdsQueryResult = Apollo.QueryResult<AdminFormTestHouseholdsQuery, AdminFormTestHouseholdsQueryVariables>;
export const AdminFormTestResultsDocument = gql`
    query AdminFormTestResults($versionID: ID!) {
  node(id: $versionID) {
    ... on FormVersion {
      id
      version
      createdAt
      kind
      form {
        id
      }
      schemaVersion
      config
    }
  }
  submissions(
    first: 10
    where: {hasFormVersionWith: [{id: $versionID, kind: TEST}]}
  ) {
    edges {
      node {
        id
        status
        household {
          id
          name: displayName
        }
        sourceDocuments {
          edges {
            node {
              id
              name
            }
          }
        }
        answers {
          id
          fieldID
          latestAIRevision {
            id
            value
            confidence
            reasoning
            evidence {
              id
              document {
                id
                name
              }
              fileParagraphs {
                id
                content
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAdminFormTestResultsQuery__
 *
 * To run a query within a React component, call `useAdminFormTestResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminFormTestResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminFormTestResultsQuery({
 *   variables: {
 *      versionID: // value for 'versionID'
 *   },
 * });
 */
export function useAdminFormTestResultsQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useQuery(AdminFormTestResultsDocument, withFetchPolicyContext(options));
}
export function useAdminFormTestResultsLazyQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useLazyQuery(AdminFormTestResultsDocument, withFetchPolicyContext({
    ...options,
    isLazy: true
  }));
}
export function useAdminFormTestResultsSuspenseQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useSuspenseQuery(AdminFormTestResultsDocument, withFetchPolicyContext(options));
}
export type AdminFormTestResultsQueryHookResult = ReturnType<typeof useAdminFormTestResultsQuery>;
export type AdminFormTestResultsLazyQueryHookResult = ReturnType<typeof useAdminFormTestResultsLazyQuery>;
export type AdminFormTestResultsSuspenseQueryHookResult = ReturnType<typeof useAdminFormTestResultsSuspenseQuery>;
export type AdminFormTestResultsQueryResult = Apollo.QueryResult<AdminFormTestResultsQuery, AdminFormTestResultsQueryVariables>;
export const AdminFormTestSubmissionDocument = gql`
    query AdminFormTestSubmission($submissionID: ID!, $sourceAfter: Cursor) {
  node(id: $submissionID) {
    __typename
    ...FormsAnswerReview_Submission
    ... on Submission {
      household {
        id
        name: displayName
      }
      formVersion {
        id
        kind
        form {
          id
        }
      }
    }
  }
}
    ${FormsAnswerReview_SubmissionFragmentDoc}`;

/**
 * __useAdminFormTestSubmissionQuery__
 *
 * To run a query within a React component, call `useAdminFormTestSubmissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminFormTestSubmissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminFormTestSubmissionQuery({
 *   variables: {
 *      submissionID: // value for 'submissionID'
 *      sourceAfter: // value for 'sourceAfter'
 *   },
 * });
 */
export function useAdminFormTestSubmissionQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useQuery(AdminFormTestSubmissionDocument, withFetchPolicyContext(options));
}
export function useAdminFormTestSubmissionLazyQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useLazyQuery(AdminFormTestSubmissionDocument, withFetchPolicyContext({
    ...options,
    isLazy: true
  }));
}
export function useAdminFormTestSubmissionSuspenseQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useSuspenseQuery(AdminFormTestSubmissionDocument, withFetchPolicyContext(options));
}
export type AdminFormTestSubmissionQueryHookResult = ReturnType<typeof useAdminFormTestSubmissionQuery>;
export type AdminFormTestSubmissionLazyQueryHookResult = ReturnType<typeof useAdminFormTestSubmissionLazyQuery>;
export type AdminFormTestSubmissionSuspenseQueryHookResult = ReturnType<typeof useAdminFormTestSubmissionSuspenseQuery>;
export type AdminFormTestSubmissionQueryResult = Apollo.QueryResult<AdminFormTestSubmissionQuery, AdminFormTestSubmissionQueryVariables>;